"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeCadenceName = decodeCadenceName;
exports.atomContent = atomContent;
exports.childrenOf = childrenOf;
exports.findPrefixed = findPrefixed;
exports.findPrefixedDeep = findPrefixedDeep;
exports.findCoordsContainer = findCoordsContainer;
exports.extractBBox = extractBBox;
exports.getNamedValue = getNamedValue;
exports.getNamedValueDeep = getNamedValueDeep;
function decodeCadenceName(s) {
    return s.replace(/#([0-9a-fA-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
}
function atomContent(node) {
    return node.type === 'atom' ? node.content : null;
}
function childrenOf(node) {
    return node.type === 'container' || node.type === 'econtainer' ? node.children : [];
}
function findPrefixed(nodes, prefix) {
    const full = `${prefix}:`;
    for (const node of nodes) {
        const content = atomContent(node);
        if (content !== null && content.startsWith(full)) {
            return content.slice(full.length);
        }
    }
    return null;
}
function findPrefixedDeep(node, prefix) {
    const full = `${prefix}:`;
    const direct = atomContent(node);
    if (direct !== null && direct.startsWith(full)) {
        return direct.slice(full.length);
    }
    for (const child of childrenOf(node)) {
        const found = findPrefixedDeep(child, prefix);
        if (found !== null) {
            return found;
        }
    }
    return null;
}
function findCoordsContainer(nodes) {
    for (const node of nodes) {
        if (node.type !== 'container' && node.type !== 'econtainer') {
            continue;
        }
        const children = node.children;
        if (children.length >= 4 && children.every((c) => c.type === 'atom')) {
            return node;
        }
        const deep = findCoordsContainer(children);
        if (deep !== null) {
            return deep;
        }
    }
    return null;
}
function extractBBox(node) {
    const container = findCoordsContainer(childrenOf(node));
    if (container === null) {
        return null;
    }
    const values = childrenOf(container).map((c) => parseInt(atomContent(c) ?? '0', 10));
    if (values.length < 4) {
        return null;
    }
    return { x1: values[0], y1: values[1], x2: values[2], y2: values[3] };
}
function getNamedValue(node, name) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        return null;
    }
    const children = node.children;
    for (let i = 0; i < children.length; i++) {
        const c = children[i];
        if (c.type === 'name' && c.content === name) {
            for (let j = i + 1; j < Math.min(i + 4, children.length); j++) {
                const candidate = children[j];
                if (candidate.type === 'value') {
                    return candidate.content;
                }
            }
        }
    }
    return null;
}
function getNamedValueDeep(node, name) {
    const direct = getNamedValue(node, name);
    if (direct !== null) {
        return direct;
    }
    for (const child of childrenOf(node)) {
        const found = getNamedValueDeep(child, name);
        if (found !== null) {
            return found;
        }
    }
    return null;
}
//# sourceMappingURL=helpers.js.map